import { OpstartplanActie } from "@/entities/actie";
import { TreinserieFormData } from "@/entities/opstartplan";
import { createContext, useContext } from "react";

type OpstartplanActieDialogContextType = {
    actie: OpstartplanActie;
    updateTreinnummer: (data: TreinserieFormData, serie: number) => void;
    deleteTreinnummer: (serie: number, nummer: number) => void;
    resetAll: () => void;
};

export const OpstartplanActieDialogContext = createContext<OpstartplanActieDialogContextType | null>(null);

export function useOpstartplanActieDialogContext(): OpstartplanActieDialogContextType {
    const ctx = useContext(OpstartplanActieDialogContext);
    if (!ctx) {
        throw new Error("Use useOpstartplanActieDialogContext within <OpstartplanActieDialogContext />");
    }

    return ctx;
}
